import { PATH_NAMES } from '../constants';

export const config = {
  shopsNextPath: PATH_NAMES.SELECT_PARTNER,
  partnersPrevPath: PATH_NAMES.SELECT_ADDRESS,
  selectDatePrevPath: PATH_NAMES.SELECT_PARTNER,
  aboutYouPrevPath: PATH_NAMES.SELECT_DATE,
  reviewPrevPath: PATH_NAMES.ABOUT_YOU,

  editShopNextPath: PATH_NAMES.EDIT_PARTNER,
  editPartnerPrevPath: PATH_NAMES.EDIT_ADDRESS,
  editDatePrevPath: PATH_NAMES.EDIT_PARTNER,
};
